import { render, staticRenderFns } from "./ConnectionsTableItem.vue?vue&type=template&id=3178b7a8&scoped=true"
import script from "./ConnectionsTableItem.vue?vue&type=script&lang=js"
export * from "./ConnectionsTableItem.vue?vue&type=script&lang=js"
import style0 from "./ConnectionsTableItem.vue?vue&type=style&index=0&id=3178b7a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3178b7a8",
  null
  
)

export default component.exports